// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

function themeStyles(theme) {
  var match = theme.components;
  var tag = match.tag;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.backgroundColor(tag.backgroundColor),
              BsCssJs$PrezzeeRibbon.color(tag.color)
            ]);
}

var tag = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("inlineBlock"),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(14)),
      BsCssJs$PrezzeeRibbon.lineHeight({
            NAME: "abs",
            VAL: 1.5
          }),
      BsCssJs$PrezzeeRibbon.fontWeight("semiBold"),
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(22)),
      BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.rem(0.75)),
      BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.rem(0.75)),
      BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.rem(0.25)),
      BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.rem(0.25)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.smallScreenOrMobile, [BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(12))])
    ]);

var Styles = {
  themeStyles: themeStyles,
  tag: tag
};

function Tag(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx("span", {
              children: props.children,
              className: Classnames([
                    tag,
                    themeStyles(theme),
                    className$1
                  ])
            });
}

var make = Tag;

export {
  Styles ,
  make ,
}
/* tag Not a pure module */
